import React, { useContext, useMemo } from 'react';
import { priceContext } from '../PriceConfigProvider';
import { IS_T3_WEBSITE } from '../../constants/environment';
import PriceInfoT3 from './PriceInfo-T3';
import PriceInfoT1 from './PriceInfo-T1';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const DealerPriceInfo = () => {
  const priceConfig = useContext(priceContext);
  console.log('🚀 ~ DealerPriceInfo ~ priceConfig (use provider):', priceConfig);

  const renderContent = useMemo(() => {
    if (IS_T3_WEBSITE) return <PriceInfoT3 />;
    return <PriceInfoT1 />;
  }, []);

  return renderContent;
};

export default DealerPriceInfo;
